import React  from 'react';
import ListComponentProto from './rating-proto.jsx';


export default function renderListInFormNew(id, props) {
    return <ListComponentProto renderMode="form-new" id={id} {...props} />;
}